<ng-container *transloco="let t; read: 'configuration'">
<div class="rounded-lg fixActionRow">
  <div class="flex justify-between">
    <h1 class="text-[25px] font-bold">{{ t('activityBank.addActivity') }}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content class="relative">
    <!-- Domain display -->
    <div class="flex items-center gap-2 mb-4 p-3 bg-gray-50 rounded-md">
      <img
        class="h-8 w-8"
        src="assets/images/domains/{{ data.iconName }}"
        [alt]="data.domainName"
      />
      <!-- Server-supplied domain name: localized by the API, not by Transloco. -->
      <span class="font-semibold text-lg">{{ data.domainName }}</span>
    </div>

    <form class="grid grid-cols-2 gap-x-4 gap-y-4 py-2" [formGroup]="activityForm">
      <div class="col-span-1">
        <drdp-select-measure
          #measureSelect
          (measure)="onMeasureSelect($event)"
          [domainId]="data.domainId"
          [clear]="clearMeasure"
          [required]="true"
          [multiSelect]="false"
        ></drdp-select-measure>
      </div>

      <div class="col-span-1">
        <drdp-select-level
          #levelSelect
          (level)="onLevelSelect($event)"
          [clear]="false"
          [required]="true"
          [multiSelect]="false"
        ></drdp-select-level>
      </div>

      <div class="col-span-2 items-center w-[100%]">
        <div class="flex justify-between items-center mb-1">
          <label class="font-normal" [class.required]="!isSpanish" for="description">
            {{
              isSpanish
                ? t('activityBank.form.spanishDescriptionLabel')
                : t('activityBank.form.englishDescriptionLabel')
            }}
          </label>
          <div class="flex items-center gap-2">
            <span [class.font-semibold]="!isSpanish">{{ t('activityBank.form.englishToggle') }}</span>
            <mat-slide-toggle [(ngModel)]="isSpanish" [ngModelOptions]="{standalone: true}" color="primary"></mat-slide-toggle>
            <span [class.font-semibold]="isSpanish">{{ t('activityBank.form.spanishToggle') }}</span>
          </div>
        </div>

        @if (!isSpanish) {
          <textarea matInput [placeholder]="t('activityBank.form.englishDescriptionLabel')" autocomplete="off" id="description" 
              class="w-full h-40 border border-gray-300 rounded-md p-2"
              formControlName="description" maxlength="1000" required>
          </textarea>
        } @else {
          <textarea matInput [placeholder]="t('activityBank.form.spanishDescriptionLabel')" autocomplete="off" id="spanishDescription" 
              class="w-full h-40 border border-gray-300 rounded-md p-2"
              formControlName="spanishDescription" maxlength="1000">
          </textarea>
        }
      </div>
    </form>
  </div>

  <div class="spacer"></div>
  <div mat-dialog-actions class="flex justify-end align-bottom">
    <drdp-btn color="cancel" class="mr-2" mat-button mat-dialog-close>{{ t('common.cancel') }}</drdp-btn>
    <drdp-btn mat-button [disabled]="activityForm.invalid || !selectedMeasureId || !selectedLevelId" 
      cdkFocusInitial (click)="onSubmit()">{{ t('common.save') }}</drdp-btn>
  </div>
</div>
</ng-container>
